import { RightOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import React, { useState } from 'react';

import { TableCell } from '../TableCell/TableCell';

import styles from './CollapsibleTableRow.module.scss';

const { Panel } = Collapse;

export type CollapsibleTableRowProps = {
  headerContent?: ReactNode;
  children: ReactNode;
  panelKey: string;
  columns?: number;
  className?: string;
  onChange?: (key: string | string[]) => void;
  defaultActiveKey?: string[];
  label: string;
};

export const CollapsibleTableRow: React.FC<CollapsibleTableRowProps> = ({
  headerContent,
  children,
  panelKey,
  columns = 16,
  className = '',
  onChange,
  defaultActiveKey,
  label,
}) => {
  const [activeKey, setActiveKey] = useState<string[]>(defaultActiveKey ?? []);

  const handleChange = (key: string | string[]) => {
    const keys = Array.isArray(key) ? key : [key];

    setActiveKey(keys);
    onChange?.(key);
  };

  return (
    <Collapse
      className={classNames(styles.collapsibleTableRow, className)}
      ghost
      expandIcon={() => null}
      activeKey={activeKey}
      onChange={handleChange}
    >
      <Panel
        key={panelKey}
        className={styles.innerCollapsible}
        header={
          <div
            className={classNames([styles.headerRow])}
            style={{
              gridTemplateColumns: `minmax(154px, 186px) repeat(15, 1fr)`,
            }}
          >
            <TableCell isRowTitle align="left">
              <RightOutlined className="collapseIcon" />
              {label}
            </TableCell>
            {headerContent}
          </div>
        }
      >
        {children}
      </Panel>
    </Collapse>
  );
};
